/***
*
*   FEATURES
*   Feature list for use on home/landing pages
*
**********/

import React from 'react';
import { Grid, Icon } from 'components/lib';
import Style from './features.module.scss';

export function Features(props){

  return(
    <div className={ Style.features }>
      <Grid cols={ 3 }>

        <div>
        <Icon image='users' size={ 18 } color={ props.iconLanding ? 'landing' : null }/>
        <h3>Deal Finder</h3>
        <p>Introduce el perfil que deseas obtener y te daremos los perfiles que más se ajusten para que este sea tu punto de partida..</p>
        </div>

        <div>
        <Icon image='pie-chart' size={ 18 } color={ props.iconLanding ? 'landing' : null }/>
        <h3>LEAD PROFILING</h3>
        <p>No importa si subiste tu base de prospectos o la generó la herramienta, analizaremos todo eso y más para conocerlos más y segmentar de forma inteligente.</p>
        </div>

        <div>
        <Icon image='message-circle' size={ 18 } color={ props.iconLanding ? 'landing' : null }/>
        <h3>CUSTOM COMMUNICATIONS</h3>
        <p>Se acabó enviar lo mismo a toda la audiencia. Si ya les conoces, escríbeles cuándo, cómo y lo que quieren escuchar. Todo esto, ¡automático!</p>
        </div>

        <div>
        <Icon image='mail' size={ 18 } color={ props.iconLanding ? 'landing' : null }/>
        <h3>IA CONTENT CREATOR</h3>
        <p>Escribir un correo diferente para cada cliente es impensable. Deja que Deal Finder escriba las comunicaciones por ti con lo último en NLP.</p>
        </div>

        <div>
        <Icon image='bar-chart' size={ 18 } color={ props.iconLanding ? 'landing' : null }/>
        <h3>ANALYTICS DRIVEN</h3>
        <p>Medir y tomar decisiones. Medir y tomar decisiones. Medir y tomar decisiones. Repite hasta que funcione. El envío de campañas es dinámico y aprende sobre la marcha. No más mediciones después de enviar miles de correos.</p>
        </div>

        <div>
        <Icon image='dollar-sign' size={ 18 } color={ props.iconLanding ? 'landing' : null }/>
        <h3>SALES ASSITANT</h3>
        <p>Si tienes vendedores, ayúdales con un informe que les diga cómo tratar a cada cliente para aumentar las ventas, introducir nuevos productos o fidelizarle.</p>
        </div>

      </Grid>
    </div>
  );
}
